<template>
  <div class="title-area">
    <div class="title-text">{{text}}</div>
    <div v-if=isModal class="close" @click="clickClose">×</div>
    <TextLinkInline v-if="isSearch &&! showHelpModal" class="help" text="情報/ヘルプ" @click-text="onCkickHelp" />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import TextLinkInline from '@/components/Atoms/TextLinkInline'

export default {
  name: 'title-area',
  components: {
    TextLinkInline
  },
  props: {
    text: { type: String },
    isModal: { type: Boolean, default: false }
  },
  computed: {
    ...mapState(['showHelpModal']),
    isSearch () {
      return this.$route.path === '/search'
    }
  },
  methods: {
    ...mapMutations(['closeModalAll', 'oepnHelpModal']),
    clickClose (e) {
      this.closeModalAll()
    },
    onCkickHelp (e) {
      this.oepnHelpModal()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.title-area {
  position:fixed;
  top:0rem;
  width: 100%;
  background-color: $gray;
  margin: 0em;
  text-align: center;
  padding: 0.3em 0em;
  min-height: 2rem;
}
.close{
  position: absolute;
  font-weight: bold;
  font-size:2rem;
  right:1.0rem;
  top:0rem;
}
.help{
  position: absolute;
  font-size:0.8rem;
  right:0.5rem;
  top:0.6rem;
}
.title-text{
  font-size: 1.3em;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TitleArea.vue